import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { Facebook, Instagram, Youtube, Mail } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = React.useState("");
  const [footerPages, setFooterPages] = React.useState([]);
  React.useEffect(() => { api.get("/pages?footer=true").then(({ data }) => setFooterPages(data)).catch(() => {}); }, []);
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    try { await api.post("/newsletter", { email }); toast.success("Благодарим! Записахме Ви."); setEmail(""); }
    catch { toast.error("Възникна грешка."); }
  };

  const cols = [
    { title: "Магазин", links: [["Картини", "/kartini"], ["Колекции", "/kartini?view=collections"], ["Подаръци", "/podaratsi"], ["Блог", "/blog"], ["За художника", "/za-avtora"]] },
  ];

  return (
    <footer className="bg-navy text-ivory mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo light />
          <p className="text-ivory/70 text-sm mt-4 leading-relaxed">
            PenichArt събира авторски картини, създадени с внимание към детайла, цвета и настроението.
          </p>
          <div className="flex gap-3 mt-5">
            {[Facebook, Instagram, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 border border-gold/40 flex items-center justify-center text-gold hover:bg-gold hover:text-navy transition-colors" data-testid={`social-${i}`}>
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="font-serif text-lg text-gold mb-4">{c.title}</h4>
            <ul className="space-y-2.5">
              {c.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="text-ivory/70 text-sm hover:text-gold transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <h4 className="font-serif text-lg text-gold mb-4">Информация</h4>
          <ul className="space-y-2.5">
            {footerPages.map((p) => (
              <li key={p.id}><Link to={`/stranitsa/${p.slug}`} className="text-ivory/70 text-sm hover:text-gold transition-colors" data-testid={`footer-page-${p.slug}`}>{p.title}</Link></li>
            ))}
            <li><Link to="/kontakti" className="text-ivory/70 text-sm hover:text-gold transition-colors">Контакти</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg text-gold mb-4">Бюлетин</h4>
          <p className="text-ivory/70 text-sm mb-4">Получавайте нови картини и специални селекции.</p>
          <form onSubmit={subscribe} className="flex" data-testid="newsletter-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   placeholder="Вашият имейл"
                   className="flex-1 bg-ivory/10 border border-gold/40 px-3 py-2.5 text-sm text-ivory placeholder:text-ivory/40 outline-none focus:border-gold"
                   data-testid="newsletter-input" />
            <button type="submit" className="btn-gold px-4 text-sm rounded-none" data-testid="newsletter-submit">Запиши ме</button>
          </form>
          <div className="flex items-center gap-2 text-ivory/60 text-sm mt-5">
            <Mail size={15} className="text-gold" /> info@penichart.org
          </div>
        </div>
      </div>
      <div className="border-t border-ivory/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-col sm:flex-row items-center justify-center gap-2 text-center text-ivory/50 text-xs">
          <span>© {new Date().getFullYear()} PenichArt. Всички права запазени.</span>
          <span className="hidden sm:inline">·</span>
          <Link to="/admin" className="hover:text-gold transition-colors" data-testid="footer-admin-link">Админ панел</Link>
        </div>
      </div>
    </footer>
  );
}
